import MenuItem from "./MenuItem";

// let cincoDeMayo = [
//     MenuItem("Tlayuda With Chorizo","19.00",""),
//     MenuItem("Suadero Tacos","11.85",""),
//     MenuItem("Pastor Tacos","11.85",""),
//     MenuItem("Chicken Tacos","11.85",""),
//     MenuItem("Chorizo Tacos","11.85",""),
//     MenuItem("Carbon Tacos","11.85",""),
//     MenuItem("Tinga Tostadas","7.90","Two crispy tostadads topped with beans, quesos, lettuce, sosur cream and tinga chicken covered with chipotle sauce"),
//     MenuItem("Mangonada","7.85",""),
// ]
let appetizers = [
    MenuItem("Chips y Salsa", "3.50", ""),
    MenuItem("Guacamole", "11.00", "Freshly made with avocados, onions, tomatoes, limes, cilantro served with tortilla chips. Add salsa for 2.00."),
    MenuItem("Nachos", "13.00", "Crispy corn chips, covered with refried beans, queso fresco, morita aioli, salsa verde, jalapeños, pico de gallo and a drizzle of sour cream. Add side of guacamole for 4.00, Add chicken, chorizo, or pastor for 5.00, Add Carne Asada for 6.50, Add Shrimp for 8.00"),
    MenuItem("Quesadillas", "12.00", "A flour tortilla filled with Monterrey Jack, queso Oaxaca, guacamole, cream, and salsa. Add chicken, chorizo, or pastor for 5.00, Add carne asada or suadero for 6.50, Add shrimp for 8.00"),
    MenuItem("Queso Fundido", "11.00", "Melted Jack cheese, Queso Oaxaca, jalapeño peppers, and cilantro served with corn tortillas. Add chorizo, mushrooms, or cactus for 3.50"),
    MenuItem("Sopes", "7.50", "Two sopes topped with pork lard, green sauce, red sauce, tomato sauce, sour cream, and queso fresco. Add chorizo or pastor for 5.00, Add carne asada or suadero for 6.00"),
    MenuItem("Tlayudas", "18.00", "Pork lard, refried beans, cabbage, lettuce, tomato, avocado, cheese and serrano rajas. Add chicken, chorizo or carne enchilada (pork) for 7.00, Add carne asada or suadero for 8.00, Add campechano/mix for 9.00"),
    MenuItem("Camarones Sabor Mixteco", "16.00", "Sautéed shrimp bathed in garlic, butter, white wine, and cilantro, served with bread"),
    MenuItem("Sabor Mixteco Salad", "9.00", "Romaine lettuce, avocado, onions, tomatoes, radishes, dressed with Sabor Mixteco’s vinaigrette. Add grilled chicken or carne enchilada for 6.00, Add carne asada for 8.00, Add shrimp for 8.00"),
    MenuItem("Ensalada De Nopales", "11.00", "Grilled cactus, romaine lettuce, radish, onion, avocado and queso fresco dressed with vinaigrette. Add shrimp for 8.00"),
    MenuItem("Pancita", "17.00", "Mexican guajillo chili broth with cow tripe and feet."),
    MenuItem("Pozole Rojo", "17.00", "A traditional mexican pork and hominy corn soup with a red chiles broth. Served with onions, radish, and avocado."),
]

let tacos = [
    MenuItem("Al Pastor", "4.00", "Pork marinated in adobo"),
    MenuItem("Suadero", "4.50", "Braised beef"),
    MenuItem("Chorizo", "4.00", "Mexican sausage(pork)"),
    MenuItem("Al Carbon", "4.50", "Carne asada"),
    MenuItem("Lengua", "5.50", "Cow tongue"),
    MenuItem("Pollo", "4.00", "Grilled chicken"),
    MenuItem("Taco Vegetariano", "12.00", "Three tacos with poblano peppers, bell peppers, mushrooms, onions and queso fresco"),
    MenuItem("Camarones", "23.00", "Three shrimp tacos with red onions, poblano and bell peppers on flour tortillas covered with avocado, and morita crema. Served with rice and beans"),
    MenuItem("Pescado", "25.00", "Three fish tacos with cabbage, pico de gallo, and morita mayo on flour tortillas served with rice and beans"),
]

let signatures = [
    MenuItem("Enchiladas Verdes", "19.00", "Three enchiladas served with salsa verde, sour cream, onion, queso fresco and a side of rice and beans. Choice of only one protein: chicken, cheese or vegetables. Choice of braised Beef for 3.00 "),
    MenuItem("Enchiladas Mixtecas(Mole)", "23.00", "Three traditional mole enchiladas with queso fresco, onion, radish and a side of rice and beans. Choice of only one protein: chicken, cheese or vegetables."),
    MenuItem("Enchiladas Rojas(Pasilla)", "19.00", "Three enchiladas served with pasilla sauce, sour cream, onion, queso fresco and a side of rice and beans. Choice of only one protein: chicken, cheese or vegetables. Choice of braised Beef for 3.00."),
    MenuItem("Enchiladas Divorciadas", "22.00", "Two chicken enchiladas one topped with green sauce the other with red pasilla sauce, served with queso fresco, guacamole, rice, and beans"),
    MenuItem("Enchiladas Las Tres Marias", "24.00", "Three enchiladas stuffed with cheese and chorizo, one topped with green sauce, one with red sauce and one with mole. Served with guacamole, rice and beans"),
    MenuItem("Flautas De Pollo", "18.00", "Three crispy corn tortillas tacos filled with pulled chicken, covered with sour cream, queso fresco, onions and shredded lettuce. Served with rice and beans"),
    MenuItem("Guisado De Salsa Pasilla", "23.00", "Choice of beef, chicken, or pork cooked in salsa pasilla (tomato, chile pasilla, garlic, cactus) served with tortillas, rice and beans"),
    MenuItem("Bistec A La Mexicana", "21.00", "Beef cooked in tomato, onion, cilantro, and jalapeno, served with tortillas, rice, and beans "),
    MenuItem("Carne Asada", "35.00", "New York Strip served with onions, rice and beans. Add shrimp for 8.00"),
    MenuItem("Chilaquiles Verdes", "15.00", "Tortilla chips covered with green tomatillo salsa, onions, sour cream, queso fresco, and beans. Add two eggs for 3.00, Add chorizo, chicken or carne enchilada for 6.00, Add carne asada for 8.00"),
]

let mariscos = [
    MenuItem("Camarones En Salsa Pasilla", "24.00", "Shrimp cooked in salsa pasilla, served with rice and a salad"),
    MenuItem("Camarones Al Mojo De Ajo", "24.00", "Shrimps cooked in butter, garlic, guajillo peppers and white wine, served with rice and a salad"),
    MenuItem("Camarones En Salsa Verde", "24.00", "Shrimp sauteed in a green tomatillo sauce served with rice and a salad"),
    MenuItem("Camarones Veracruzana", "24.00", "Shrimp cooked in tomato sauce, olives, garlic, onion, bell peppers and capers. Served with rice and a salad"),
    MenuItem("Huachinango Al Mojo De Ajo", "27.00", "Red snapper cooked in butter, garlic, guajillo peppers and white wine, served with a rice and a salad"),
    MenuItem("Huachinango Amarillito", "27.00", "Red snapper cooked in amarillito, a traditional sauce made with huajillo peppers, garlic, mushrooms, hoja santa and chicken broth thickened with corn masa. served with a rice and a salad"),
    MenuItem("Huachinango Veracruz", "27.00", "Red snapper cooked in tomato sauce, olives, garlic, onion, bell peppers and capers. Served with rice and a salad."),
    MenuItem("Filete de Pescado Frito", "25.00", "Fried red snapper served with rice and a salad"),
]

let burritos = [
    MenuItem("Pastor Burrito", "13.00", "Marinated pork"),
    MenuItem("Chorizo Burrito", "13.00", "Mexican sausage(pork), add eggs for 3.00"),
    MenuItem("Suadero Burrito", "14.00", "Braised beef"),
    MenuItem("Carne Asada Burrito", "14.00", "Grilled Beef"),
    MenuItem("Pollo Burrito", "13.00", "Chicken"),
    MenuItem("Vegetariano Burrito", "13.00", "Vegetables of the day"),
]

let oaxacanPlatters = [
    MenuItem("Tasajo", "25.00", "Thin sliced of grilled tasajo(beef) served with grilled cactus, caramelized onions, queso fresco, guacamole, rice, beans and corn or flour tortillas. Add grilled shrimp for 8.00"),
    MenuItem("Carne Enchilada", "24.00", "Thin sliced of carne enchilada(marinated pork) served with grilled cactus, caramelized onions, queso fresco, guacamole, rice, beans and corn or flour tortillas. Add grilled shrimp for 8.00"),
    MenuItem("Mole Mixteco", "25.00", "Bone in chicken covered with a traditional thick and rich sauce made from a blend of chiles, fruit, spices, sesame seeds, and chocolate. Served with rice, and beans"),
    MenuItem("Amarillito Mole", "23.00", "Bone in chicken covered with amarillito sauce, a traditional sauce made with huajillo peppers, garlic, mushrooms, hoja santa and chicken broth thickened with corn masa. Served with rice, and beans"),
    MenuItem("Vegetarian Combo", "23.50", "A chile relleno served with a green cheese enchilada, rice and beans"),
    MenuItem("Chileajo Mixteco", "19.00", "Pork and potatoes covered in a flavourful thick sauce made with dried peppers, garlic, herbs. Served with rice and beans."),
    MenuItem("Chile Rellenos", "20.00", "Poblano pepper stuffed with queso Oaxaca, covered in a fluffy egg wash, submerged in a Oaxacan tomato sauce. Served with rice and beans"),
]

let alambres = [
    MenuItem("Carne Asada", "21.00", "Grilled beef"),
    MenuItem("Al Pastor", "20.00", "Pork marinated in guajillos peppers and other spices with pineapple"),
    MenuItem("Chorizo", "20.00", "Mexican sausage(pork)"),
    MenuItem("Pollo", "20.00", "Grilled chicken"),
    MenuItem("Suadero", "21.00", "Braised beef"),
    MenuItem("Verduras", "20.00", "Poblano peppers, bell peppers, mushrooms and onions"),
    MenuItem("Sabor Mixteco", "23.00", "(Campechano)Mexican sausage, and braised beef"),
    MenuItem("Camarones", "23.00", "Baby shrimps")
]

let tortas = [
    MenuItem("Al Pastor", "15.00", "Marinated pork in adobo"),
    MenuItem("Chorizo", "15.00", "Mexican sausage(pork). Add scrambled eggs for 3.00"),
    MenuItem("Carne Asada", "16.00", "Grilled beef"),
    MenuItem("Suadero", "16.00", "Braised beef"),
    MenuItem("Jamon", "14.00", "Ham"),
    MenuItem("Pollo", "15.00", "Grilled chicken"),
    MenuItem("Sabor Mixteco", "18.00", "Traditional chileajo (pork stew) torta served with beans and onions"),
]

let kidsMenu = [
    MenuItem("Sincronizada", "9.00", "Ham and cheese quesadilla served with rice and beans"),
    MenuItem("Chicken Taquitos", "9.00", "Crispy chicken taquitos served with rice and beans"),
    MenuItem("Quesadilla", "9.00", "A cheese quesadilla with sour cream served with rice and beans. Add chicken for 2.00"),
    MenuItem("Pollo Niño", "9.00", "Grilled chicken served with rice and beans"),
]

let sides = [
    MenuItem("Mexican Rice", "4.50", ""),
    MenuItem("Beans", "4.50", ""),
    MenuItem("Nopales(Cactus)", "6.00", ""),
    MenuItem("Tortillas", "3.00", "Four flour or corn tortillas"),
    MenuItem("French Fries with Chipotle Aioli", "7.00", ""),
    MenuItem("Guacamole", "5.00", ""),
    MenuItem("Avocado Slices", "5.00", ""),
    MenuItem("Queso Fresco", "5.00", "")
]

let desserts = [
    MenuItem("Flan", "8.00", ""),
    MenuItem("Tres Leches", "9.00", ""),
    MenuItem("Nieve", "9.00", "Ask for flavor of the day"),
    MenuItem("Kids Ice Cream", "4.50", "One scoop of the flavor of the day"),
    MenuItem("Tea", "4.00", ""),
    MenuItem("Coffee", "4.00", ""),
    MenuItem("Coffee Mixteco", "12.00", "Coffee served with mezcal and coffee liquor"),
    MenuItem("Mariachi Coffee","12.00","Tequila and whipped cream"),
    ]

let drinks = [
    MenuItem("Soft Drinks", "3.00", "Coca cola, ginger ale, or diet coke"),
    MenuItem("Mexican Sodas", "4.25", "Mexican coca cola, tamarind jarrito, or mandarine jarrito"),
    MenuItem("Aguas Frescas", "4.00", "Tepache, maracuya, tamarindo, jamaica, or mango"),
    MenuItem("Horchata", "4.25", "Rice and cinammon milk"),
    MenuItem("Orange Juice", "4.00", ""),
    MenuItem("Prepared Mineral Water", "6.00", ""),
]

let tlayudaMonday = [
    MenuItem("Chorizo Tlayuda Special","23.00","A toast coverede with chorizo, pork lard, refried beans, cabbage, lettuce, tomato, avocado and cheese."),
]

let tacoTuesday = [
    MenuItem("Taco Tuesday Special", "13.00", "4 tacos"),
]

var menu = {
    "Taco Tuesday" : ["Only available on Tuesday", tacoTuesday],
    "Tlayuda Monday" : ["Only available on Monday", tlayudaMonday],
    "Appetizers" : ["", appetizers],
    "Tacos" : ["Served with cilantro and onions. Add rice and beans for 4.50", tacos],
    "Signature Dishes" : ["", signatures],
    "Mariscos" : ["", mariscos],
    "Burrito" : ["Served with rice, beans, lettuce, salsa, cheese and sour cream, served with your choice of filling. Add guacamole for 4.00", burritos],
    "Oaxacan Platters" : ["", oaxacanPlatters],
    "Alambres" : ["Served with mixed poblanos, bell peppers, cilantro, onions, melted cheese, and corn or flour tortillas. Add rice and beans for 4.50", alambres],
    "Tortas" : ["Mexican sandwich filled with refried beans, onion, mayo, tomato, avocado, pickled jalapeno and Oaxacan cheese", tortas],
    "Sides" : ["", sides],
    "Desserts" : ["", desserts],
    "Drinks" : ["", drinks],
    "Kids Meal" : ["For dine in only, kids younger than 10. Served with rice and beans", kidsMenu]
}

// This code can allow you to only show certaiin menu categories based on the weekday
// let date = new Date()

// let daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
// let currWeekDay = daysOfWeek[date.getDay()]

// menu = Object.entries(menu).reduce(((acc, [key, value]) => {
//     if(value !== null) {
//         acc[key] = value
//     }
//     return acc
// }, {}))

// Lunch Menu
let lunchEntrees = [
    MenuItem("Huevos A La Mexicana", "12.00", "Scrambled eggs with tomato, onions, and jalapeños. Served with tortillas, rice and beans."),
    MenuItem("Huevos Con Chorizo", "14.00", "Scrambled egg with Mexican sausage. Served with tortillas, rice and beans."),
    MenuItem("Huevos Rancheros", "13.00", "Fried eggs with green sauce over tortillas. Served with rice and beans."),
    MenuItem("Huevos Divorciados", "14.00", "Fried eggs with red and green sauce. Served with queso fresco, tortillas, rice and beans."),    
    MenuItem("Huevos En Salsa Con Nopales", "15.00", "Scrambled eggs with cactus and your choice of pasilla or green sauce. Served with tortillas, rice and beans. "),    
    MenuItem("Huevos Con Mole", "18.00", "Fried eggs with mole served with rice, beans and tortillas."),
    MenuItem("Enfrijoladas", "14.00", "Black bean sauce, cheese, sour cream, onions, cilantro and queso fresco. Served wih rice. "),
    MenuItem("El Desayuno De La Casa", "20.00", "Fried eggs with fried carne enchilada, served with avocado, rice and beans"),
    MenuItem("Lunch Carne Adobada", "13.50", "Marinated pork, and sauteed onions served with rice, beans, and tortillas. "),
    MenuItem("Lunch Carne Asada", "15.00", "Grilled beef and sauteed onions served with rice, beans, and tortillas. "),    
    MenuItem("Lunch Pollo Asado", "13.50", "Grilled chicken and sauteed onions served with rice, beans, and tortillas."),    
    MenuItem("Sincronizada", "14.00", "Flour tortillas filled with ham, and cheese, served with pico de gallo and guacamole"),
    MenuItem("Chilaquiles Criollos", "19.00", "Deep fried tlayuda tortilla covered with salsa verde, salsa roja, queso fresco, sour cream, onions, radish and avocado topped with fried eggs. With a side of beans"),
]    

let lunchAlambres = [
    MenuItem("Carne Asada", "14.00", "Grilled beef"),
    MenuItem("Al Pastor", "13.00", "Pork marinated in guajillos peppers and other spices with pineapple"),
    MenuItem("Chorizo", "13.00", "Mexican sausage(pork)"),
    MenuItem("Pollo", "13.00", "Grilled chicken"),
    MenuItem("Suadero", "14.00", "Braised beef"),
    MenuItem("Verdura", "13.00", "Poblano peppers, bell peppers, mushrooms and onions"),
    MenuItem("sabor Mixteco Alambre", "15.00", "Mexican sausage and braised beef")
]

let combos = [
    MenuItem("Al Pastor Combo", "11.50", "Three tacos al pastor(Marinated pork)"),
    MenuItem("Pollo Combo", "11.50", "Three chicken tacos"),
    MenuItem("Chorizo Combo", "11.50", "Three tacos with mexican sausage"),
    MenuItem("Suadero Combo", "12.50", "Three braised beef tacos"),
    MenuItem("Carbon Combo", "12.50", "Three grilled beef tacos"),
]

let lunchMenu = {
    "Lunch Entrees" : ["Add extra eggs for 3.50. Add chorizo or carne enchilada for 6.00, or carne asada for 6.50.", lunchEntrees],
    "Lunch Alambres" : ["Served with bell peppers, poblano peppers, onions, cilantro, cheese and tortillas. Add rice and beans for 4.50, add extra eggs for 3.50", lunchAlambres],
    "Taco Combos" : ["Add rice and beans for 4.50", combos],
}

//Catering Menu
let fiestaPlatters = [
    MenuItem("15 Tacos", "55.00", ""),
    MenuItem("30 Tacos", "107.00", ""),
    MenuItem("5 Burritos", "54.00", ""),
    MenuItem("10 Burritos", "105.00", ""),
    MenuItem("5 Tortas", "67.00", ""),
    MenuItem("10 Tortas", "130.00", ""),
    MenuItem("32 oz of Beans", "12.00", ""),
    MenuItem("32 oz of Mexican Rice", "10.00", ""),
    MenuItem("16 oz of Guacamole and Chips", "17.00", ""),
    MenuItem("16 oz of Salsa and Chips", "18.00", ""),
]

let cateringMenu = {
    "Fiesta Platters" : ["Filling of your choice (Pastor(pork),  chorizo(pork), chicken, grilled beef, or braised beef) ", fiestaPlatters]
}

let menus = {menu, lunchMenu}

export default menus
